export const imagify = {
    methods: {
        currentSlideSlug( slide ) {
            const { title } = slide
            const words = title.slice().split(' ').reverse()
            return ( words[0].toLowerCase() )
        },
        circleAttrs({ text, media, type, mobile, desktop }) {
            return {
                type,
                text,
                media,
                offset:     this.isMobile() ? mobile.offset : desktop.offset,
                degree:     this.isMobile() ? mobile.degree : desktop.degree,
                alttext:    media.replace('_', ' '),
            }
        },
    },
}

export const teamImage = {
    methods: {
        memberSrc( media, suffix = '_Primary' ) {
            const img = [
                `/static/members/${media}/${media}${suffix}.png`,
                `/static/members/${media}/${media}${suffix}_x2.png`,
            ]

            return `${img[0]}`
        }
    },
}

export const slideImage = {
    computed: {
        slugPath() {
            if ( this.texted ) {
                const { slug } = this
                const [ dir ] = this.text.split(' ')
                return !slug ? dir : `${slug}/${dir}`
            }

            const slug = this
                .slug.split('-')[0]
            
            return this.single
                ? slug
                : `${slug}/story`
        },
        imagePath() {
            return `${this.routePath}/${this.slugPath}`
        },
        src() {
            return this.getPath( this.slugPath, this.media )
        },
        srcset() {
            const img = [
                this.getPath( this.slugPath, this.media ),
                this.getPath( this.slugPath, this.media, '_x2.png')
            ]

            return `${img[0]} 1x, ${img[1]} 2x`
        },
    },
    methods: {
        getPath( slug, media, ext = '.png' ) {
            const mediaPath = `${slug}/${media}${ext}`
            return `/static/stories/${mediaPath}`
        },
    },
}